import {http} from '../http'
import * as featureSettingsApi from '../../coreApi/feature-settings'

import {APIResponse} from '../types'
import {Client, Person} from '../../../types'
import {handleError} from '../handleError'
import {PersonTargetFeatureRow} from './listPersonTargetFeatures'

interface Params {
  clientID: Client['ID']
  granterPersonID: Person['ID']
  targetPersonID: Person['ID']
  featureID: number
}

type CreatePersonTargetFeatureReturn = APIResponse<PersonTargetFeatureRow>

export interface CreatePersonTargetFeature {
  (params: Params): Promise<CreatePersonTargetFeatureReturn>
}

const ERROR_PATH = 'api.featuresettings.createPersonTargetFeature()'
const GENERIC_ERROR =
  'Something went wrong while granting feature access. Please try again.'

export const createPersonTargetFeature: CreatePersonTargetFeature = async ({
  clientID,
  granterPersonID,
  targetPersonID,
  featureID,
}) => {
  try {
    const startDate = new Date()
    const endDate = new Date(startDate)
    endDate.setFullYear(endDate.getFullYear() + 1)
    const response = await featureSettingsApi.createPersonTargetFeature(http, {
      ClientID: Number(clientID),
      PersonID: Number(granterPersonID),
      TargetPersonID: Number(targetPersonID),
      FeatureID: featureID,
      StartDate: startDate.toISOString(),
      EndDate: endDate.toISOString(),
    })

    return {
      result: 'success',
      data: {
        id: response.data.ID,
        clientID: response.data.ClientID,
        granterPersonID: response.data.PersonID,
        targetPersonID: response.data.TargetPersonID,
        featureID: response.data.FeatureID,
        startDate: response.data.StartDate,
        endDate: response.data.EndDate,
      },
    }
  } catch (e) {
    return handleError(ERROR_PATH, GENERIC_ERROR, e)
  }
}
